<template>
  <NavbarMenu
    ref="navbarTemplateRef"
    data-testid="navbar-template"
    :class="[
      'app-navbar',
      {
        'app-navbar__impersonate--enabled': isImpersonateFlag,
        'app-navbar--loaded': !isShowingWelcomeSession
      }
    ]"
    :menu="menu"
    :is-transparent="isTransparent"
    @tab-select="tabSelect"
  >
    <template #left>
      <ButtonIconContextual
        label="Menu"
        data-testid="menu-button"
        icon="AA0040"
        @click="openLeftSideBar"
      />
    </template>
    <template #right>
      <div class="app-navbar__right">
        <ShowMoneyToggleButton />
        <NotificationsButton />
      </div>
    </template>
  </NavbarMenu>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { ButtonIconContextual } from '@warrenbrasil/nebraska-web';
import { getMenuItems } from './navigation';
import { NavbarMenu } from './components/NavbarMenu';
import { isImpersonate } from '@/modules/common/services/partner';
import { useDashStore } from '@/modules/common/store/DashModule';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import { NotificationsButton } from '@/modules/common/components/buttons/NotificationsButton';

import { trackWealthTabClick } from './track-events';

const UIModule = namespace('UIModule');

@Component({
  components: {
    ButtonIconContextual,
    NavbarMenu,
    ShowMoneyToggleButton,
    NotificationsButton
  }
})
export default class AppNavbar extends Vue {
  readonly NebraskaColors = NebraskaColors;
  readonly dashModule = useDashStore();

  @UIModule.Getter('getIsTransparentNavBar')
  private isTransparent!: boolean;

  @UIModule.Mutation('openLeftSideBar')
  private openLeftSideBar!: () => void;

  @UIModule.Mutation('setNavBarRef')
  private setNavBarRef!: (navBarRef: Vue) => void;

  @UIModule.Getter('getIsOpenWelcomeCurtain')
  private isShowingWelcomeSession!: boolean;

  @Ref()
  private readonly navbarTemplateRef!: Vue;

  get menu() {
    return getMenuItems();
  }

  mounted() {
    this.setNavBarRef(this.navbarTemplateRef);
  }

  get isImpersonateFlag() {
    return isImpersonate();
  }

  public tabSelect(item: string) {
    if (item === 'Carteiras') {
      trackWealthTabClick();
    }
  }
}
</script>

<style lang="less" scoped>
@navbar-impersonate: 48px;
@navbar-default: 56px;

.app-navbar__impersonate {
  width: 100%;
  height: @navbar-impersonate !important;
  background: @theme-primary !important;
  position: fixed;
  top: 0;
  z-index: 15;
  color: @theme-over-primary !important;
}

.app-navbar__impersonate--enabled {
  top: @navbar-impersonate !important;
}

.impersonate__button {
  outline: none;
}

.app-navbar {
  padding: 0 @size-spacing-x400;

  @media @tabletUp {
    transition: transform 1s ease-in-out;
    transform: translateY(-64px);

    &--loaded {
      transform: translateY(0);
    }
  }

  &__right {
    display: flex;
  }
}
</style>
